import { useState } from "react"
import { useTranslation } from "react-i18next"
import { isPublicPage } from "appRedux/baseQuery"
import { useAppSelector } from "appRedux/hooks"
import useFollowings from "hooks/useFollowings"
import UsersList from "components/organisms/UsersList"
import LoginRequiredDialog from "components/molecules/LoginRequiredDialog"

type FollowingsListProps = {
  id?: number;
}

export default function FollowingsList({ id }: FollowingsListProps) {
  const [showLoginRequiredDialog, setShowLoginRequiredDialog] = useState<boolean>(isPublicPage())

  const followings = useAppSelector((state) => state.profileTabs.followings)

  const { t } = useTranslation()
  const { isFetching } = useFollowings(isPublicPage() ? undefined : id)

  function handleCloseLoginRequiredDialog() {
    setShowLoginRequiredDialog(false)
  }

  return (
    <>
      {id ? <UsersList
        users={followings}
        loading={isFetching}
        showFollowButton={true}
      /> : null}
      <LoginRequiredDialog
        open={showLoginRequiredDialog}
        message={t("auth.loginRequiredToViewFollowings")}
        onClose={handleCloseLoginRequiredDialog}
      />
    </>
  )
}
